import { useEffect, useState } from 'react';

interface ToggleButtonProps {
  condition1: string;
  condition2: string;
  initialCondition: number;
  onChange: (value: number) => void;
}

export function ToggleButton({ condition1, condition2, initialCondition = 0, onChange }: ToggleButtonProps) {
  const [value, setValue] = useState(initialCondition);

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <button
      name="switch"
      className="flex gap-1 p-1 bg-surface-elevated text-[0.9rem] rounded-full"
      onClick={(e) => {
        e.preventDefault();
        setValue(value === 0 ? 1 : 0);
      }}
    >
      <span
        className={
          value === 0 ? 'px-3 py-1 bg-surface-base rounded-full text-primary' : 'px-3 py-1 rounded-full text-primary'
        }
      >
        {condition1}
      </span>
      <span
        className={
          value === 1 ? 'px-3 py-1 bg-surface-base rounded-full text-primary' : 'px-3 py-1 rounded-full text-primary'
        }
      >
        {condition2}
      </span>
    </button>
  );
}
